<mat-accordion #accordion="matAccordion" [multi]="true">

  <ng-template #mergeFieldHistory let-entry>
    <div class="merge-history" [class.own-history]="entry.isCreator" [class.expanded]="!entry.historyHasMore || isMergeHistoryExpanded(entry)">
      <div class="merge-history-title" *ngIf="!entry.isCreator"><mat-icon aria-hidden="true">edit</mat-icon><span><strong>{{ entry.sender }}</strong> {{ 'negotiate_contract.chat.fields_updated' | translate }}</span></div>
      <div *ngFor="let field of entry.mergeFields | slice:0:(isMergeHistoryExpanded(entry) ? entry.mergeFields.length : 10); let last = last" class="merge-history-field">
        <span class="merge-history-label" [title]="field.fieldName">{{ field.fieldName }}</span>
        <div class="merge-history-values">
          <span *ngIf="field.oldValue !== ''" class="merge-history-value" [title]="field.oldValue">{{ field.oldValue }}</span>
          <span *ngIf="field.oldValue !== ''" class="merge-history-arrow" [attr.aria-label]="'negotiate_contract.chat.changed_to' | translate">→</span>
          <span class="merge-history-value" [title]="field.newValue">{{ field.newValue }}</span>
          <button *ngIf="last && entry.historyHasMore && !isMergeHistoryExpanded(entry)" type="button" class="merge-history-more" aria-expanded="false" (click)="$event.stopPropagation(); toggleMergeHistory(entry)">
            <span *ngIf="entry.mergeFields.length > 10">… </span>{{ 'negotiate_contract.chat.show_more' | translate }}
          </button>
        </div>
      </div>
      <button *ngIf="entry.historyHasMore && isMergeHistoryExpanded(entry)" type="button" class="merge-history-more merge-history-collapse" aria-expanded="true" (click)="$event.stopPropagation(); toggleMergeHistory(entry)">
        {{ 'negotiate_contract.chat.show_less' | translate }}
      </button>
      <div *ngIf="entry.historyInvalid">{{ 'negotiate_contract.chat.history_unavailable' | translate }}</div>
    </div>
  </ng-template>

  <mat-expansion-panel class="mat-elevation-z0" expanded="true" *ngIf="isNegotiate">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "negotiate_contract.label" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="chat-container">

      <!-- Danh sách tin nhắn -->
      <div class="message-list" #scrollContainer>
        <ng-container *ngIf="messages.length > 0; else noMessage" #messageItem>
          <div class="w-100 message-row d-flex" *ngFor="let msg of messages" (mouseenter)="isHover = msg.id" (mouseleave)="isHover = null" [ngClass]="msg.isCreator ? 'justify-content-end' : 'justify-content-start'">
            <div class="message position-relative" [class.merge-history-message]="msg.type === 2" [id]="'message-id-' +msg.id" [ngClass]="msg.isCreator ? 'me': 'notme'">
              <div class="sender fw-bold small mb-1" [hidden]="msg.isCreator">{{ msg.sender }}</div>
              <div class="reply-message-1  mb-2" *ngIf="msg.parent">
                <div class="reply-message-content" (click)="scrollToMessage(msg.parent)">
                  <div class="font-size-12">{{ msg.parent.isCreator ? ('negotiate_contract.chat.you' | translate) : msg.parent.sender}}</div>
                  <div class="bubble-reply" *ngIf="msg.parent.type !== 2">{{ msg.parent.content }}</div>
                  <div class="bubble-reply" *ngIf="msg.parent.type === 2">{{ msg.parent.historyInvalid ? ('negotiate_contract.chat.history_unavailable' | translate) : getNegotiateCopyText(msg.parent) }}</div>
                  <div *ngIf="msg.parent.attachments.length > 0" class="d-flex align-items-center message-file" style="margin: 0; padding: 0;">
                    <div style="width: 24px;">
                      <svg viewBox="0 0 36 36" class="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq xfx01vb" fill="currentColor" height="24" width="24" style="--color: var(--primary-icon);"><path clip-rule="evenodd" d="M18 8c0-.6-.4-1-1-1h-6a2 2 0 00-2 2v18c0 1.1.9 2 2 2h14a2 2 0 002-2V17c0-.6-.4-1-1-1h-4a4 4 0 01-4-4V8zm-6 7c0-.6.4-1 1-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3.5a1 1 0 100 2h10a1 1 0 100-2H13zm0 4.5a1 1 0 100 2h10a1 1 0 100-2H13z" fill-rule="evenodd"></path><path d="M22 14h4a1 1 0 00.7-1.7l-5-5A1 1 0 0020 8v4c0 1.1.9 2 2 2z"></path></svg>
                    </div>
                    <div style="width: 100%; flex: 1;">
                      <div style="font-size: 14px;" class="file-name">{{ msg.parent.attachments[0].fileName }}</div>
                      <div style="font-size: 11px;">{{formatFileSize(msg.parent.attachments[0].fileSize)}} <span class="mx-2">&bull;</span> {{getTailFile(msg.parent.attachments[0].fileName)}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bubble" *ngIf="msg.type !== 2 && msg.content" [innerHTML]="msg.content | linkify"></div>
              <ng-container *ngIf="msg.type === 2" [ngTemplateOutlet]="mergeFieldHistory" [ngTemplateOutletContext]="{ $implicit: msg }"></ng-container>
              <div *ngIf="msg.attachments.length > 0">
                <div *ngFor="let file of msg.attachments" class="d-flex align-items-center message-file" (click)="downLoadFileNegotiate(file)" role="button" tabindex="0">
                  <div style="width: 24px;">
                    <svg viewBox="0 0 36 36" class="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq xfx01vb" fill="currentColor" height="24" width="24" style="--color: var(--primary-icon);"><path clip-rule="evenodd" d="M18 8c0-.6-.4-1-1-1h-6a2 2 0 00-2 2v18c0 1.1.9 2 2 2h14a2 2 0 002-2V17c0-.6-.4-1-1-1h-4a4 4 0 01-4-4V8zm-6 7c0-.6.4-1 1-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3.5a1 1 0 100 2h10a1 1 0 100-2H13zm0 4.5a1 1 0 100 2h10a1 1 0 100-2H13z" fill-rule="evenodd"></path><path d="M22 14h4a1 1 0 00.7-1.7l-5-5A1 1 0 0020 8v4c0 1.1.9 2 2 2z"></path></svg>
                  </div>
                  <div style="width: 100%; flex: 1;">
                    <div class="file-name">{{ file.fileName }}</div>
                    <div class="file-size">{{formatFileSize(file.fileSize)}} <span class="mx-2">&bull;</span> {{getTailFile(file.fileName)}}</div>
                  </div>
                </div>
              </div>
              <div class="time">{{ msg.createTime | date:'HH:mm dd/MM/yyyy' }}</div>
              <div class="position-absolute message-action" [hidden]="isHover !== msg.id && isActive !== msg.id">
                <button *ngIf="canReplyNegotiation" matTooltip="{{'negotiate_contract.chat.reply' | translate}}" mat-icon-button (click)="replyMessage(msg)">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" rx="16" fill="#F5F5F5"/>
                    <path d="M10.1391 16.4051C9.97635 16.2656 9.89497 16.1959 9.86516 16.1129C9.83899 16.04 9.83899 15.9604 9.86516 15.8875C9.89497 15.8045 9.97635 15.7348 10.1391 15.5953L15.7862 10.7548C16.0664 10.5147 16.2065 10.3946 16.3251 10.3917C16.4281 10.3891 16.5266 10.4344 16.5917 10.5143C16.6667 10.6063 16.6667 10.7908 16.6667 11.1598V14.0233C18.0898 14.2723 19.3923 14.9934 20.3602 16.0761C21.4155 17.2565 21.9992 18.7842 22 20.3675V20.7755C21.3004 19.9328 20.427 19.2512 19.4395 18.7775C18.5689 18.3598 17.6277 18.1124 16.6667 18.0472V20.8406C16.6667 21.2096 16.6667 21.3941 16.5917 21.486C16.5266 21.566 16.4281 21.6112 16.3251 21.6087C16.2065 21.6057 16.0664 21.4857 15.7862 21.2455L10.1391 16.4051Z" stroke="#71717A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button matTooltip="{{'button.more_feature' | translate}}" *ngIf="getNegotiateCopyText(msg)" [matMenuTriggerFor]="menu" mat-icon-button class="btn-more" (menuOpened)="isActive = msg.id"
                (menuClosed)="isActive = null">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="32" height="32" rx="16" fill="#F5F5F5"/>
                    <path d="M15.9993 16.6666C16.3675 16.6666 16.666 16.3681 16.666 15.9999C16.666 15.6317 16.3675 15.3333 15.9993 15.3333C15.6312 15.3333 15.3327 15.6317 15.3327 15.9999C15.3327 16.3681 15.6312 16.6666 15.9993 16.6666Z" stroke="#71717A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M20.666 16.6666C21.0342 16.6666 21.3327 16.3681 21.3327 15.9999C21.3327 15.6317 21.0342 15.3333 20.666 15.3333C20.2978 15.3333 19.9993 15.6317 19.9993 15.9999C19.9993 16.3681 20.2978 16.6666 20.666 16.6666Z" stroke="#71717A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11.3327 16.6666C11.7009 16.6666 11.9993 16.3681 11.9993 15.9999C11.9993 15.6317 11.7009 15.3333 11.3327 15.3333C10.9645 15.3333 10.666 15.6317 10.666 15.9999C10.666 16.3681 10.9645 16.6666 11.3327 16.6666Z" stroke="#71717A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="copyMessage(getNegotiateCopyText(msg))">
                    <span class="fix-width">{{ 'button.copy' | translate }}</span>
                    <svg class="ml-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1511_3554)">
                      <path d="M4.16602 12.5001C3.38945 12.5001 3.00116 12.5001 2.69488 12.3732C2.2865 12.2041 1.96204 11.8796 1.79288 11.4712C1.66602 11.1649 1.66602 10.7767 1.66602 10.0001V4.33341C1.66602 3.39999 1.66602 2.93328 1.84767 2.57676C2.00746 2.26316 2.26243 2.00819 2.57603 1.8484C2.93255 1.66675 3.39926 1.66675 4.33268 1.66675H9.99935C10.7759 1.66675 11.1642 1.66675 11.4705 1.79362C11.8789 1.96277 12.2033 2.28723 12.3725 2.69561C12.4993 3.00189 12.4993 3.39018 12.4993 4.16675M10.166 18.3334H15.666C16.5994 18.3334 17.0661 18.3334 17.4227 18.1518C17.7363 17.992 17.9912 17.737 18.151 17.4234C18.3327 17.0669 18.3327 16.6002 18.3327 15.6667V10.1667C18.3327 9.23333 18.3327 8.76662 18.151 8.4101C17.9912 8.09649 17.7363 7.84153 17.4227 7.68174C17.0661 7.50008 16.5994 7.50008 15.666 7.50008H10.166C9.23259 7.50008 8.76588 7.50008 8.40937 7.68174C8.09576 7.84153 7.84079 8.09649 7.68101 8.4101C7.49935 8.76662 7.49935 9.23333 7.49935 10.1667V15.6667C7.49935 16.6002 7.49935 17.0669 7.68101 17.4234C7.84079 17.737 8.09576 17.992 8.40937 18.1518C8.76588 18.3334 9.2326 18.3334 10.166 18.3334Z" stroke="#71717A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                      <clipPath id="clip0_1511_3554">
                      <rect width="20" height="20" fill="white"/>
                      </clipPath>
                      </defs>
                    </svg>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noMessage>
          <div style="margin: auto;">
            {{ 'negotiate_contract.chat.no_message' | translate }}
          </div>
        </ng-template>
      </div>



      <!-- Ô nhập tin nhắn + Gửi -->
      <div>
        <div class="reply-message" *ngIf="replyMessageData && canReplyNegotiation">
          <div class="reply-message-content">
            <div class="font-size-12">[{{'negotiate_contract.chat.reply' | translate}}] {{ replyMessageData.isCreator ? ('negotiate_contract.chat.you' | translate) : replyMessageData.sender}}</div>
            <div class="bubble-reply" *ngIf="replyMessageData.type !== 2" style="padding-right: 20px;">{{ replyMessageData.content }}</div>
            <div class="bubble-reply" *ngIf="replyMessageData.type === 2" style="padding-right: 20px;">{{ replyMessageData.historyInvalid ? ('negotiate_contract.chat.history_unavailable' | translate) : getNegotiateCopyText(replyMessageData) }}</div>
            <div *ngIf="replyMessageData.attachments.length > 0" class="d-flex align-items-center message-file">
              <div style="width: 24px;">
                <svg viewBox="0 0 36 36" class="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq xfx01vb" fill="currentColor" height="24" width="24" style="--color: var(--primary-icon);"><path clip-rule="evenodd" d="M18 8c0-.6-.4-1-1-1h-6a2 2 0 00-2 2v18c0 1.1.9 2 2 2h14a2 2 0 002-2V17c0-.6-.4-1-1-1h-4a4 4 0 01-4-4V8zm-6 7c0-.6.4-1 1-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3.5a1 1 0 100 2h10a1 1 0 100-2H13zm0 4.5a1 1 0 100 2h10a1 1 0 100-2H13z" fill-rule="evenodd"></path><path d="M22 14h4a1 1 0 00.7-1.7l-5-5A1 1 0 0020 8v4c0 1.1.9 2 2 2z"></path></svg>
              </div>
              <div style="width: 100%; flex: 1;">
                <div class="file-name">{{ replyMessageData.attachments[0].fileName }}</div>
                <div class="font-size-12">{{formatFileSize(replyMessageData.attachments[0].fileSize)}} <span class="mx-2">&bull;</span> {{getTailFile(replyMessageData.attachments[0].fileName)}}</div>
              </div>
            </div>
            <button mat-icon-button class="clear-reply-btn" (click)="clearReplyMessageData()"><mat-icon>close</mat-icon></button>
          </div>
        </div>
        <div class="input-container d-flex align-items-center p-2 border-top position-relative" *ngIf="document.status == 1 && isComment">
          <div style="width: 34px; margin-left: 8px;">
            <button mat-icon-button (click)="fileInput.click()" matTooltip="{{ 'negotiate_contract.chat.attach' | translate }}">
              <svg width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.825195" width="33.7153" height="33.7153" rx="16.8576" fill="#FDE6EB"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.222 9.80614C16.9813 7.16488 21.4428 7.16488 24.2022 9.80614C26.9788 12.464 26.9788 16.7865 24.2022 19.4444L16.7495 26.5782C14.7897 28.4542 11.6244 28.4542 9.66461 26.5782C7.68747 24.6857 7.68746 21.604 9.66461 19.7114L17.0101 12.6802C18.1704 11.5696 20.0393 11.5696 21.1996 12.6802C22.3773 13.8075 22.3773 15.6484 21.1996 16.7756L13.8006 23.8581C13.52 24.1267 13.0748 24.117 12.8062 23.8364C12.5377 23.5558 12.5474 23.1107 12.828 22.8421L20.2271 15.7596C20.8261 15.1861 20.8261 14.2697 20.2271 13.6963C19.6106 13.1062 18.5991 13.1062 17.9826 13.6963L10.6372 20.7275C9.23862 22.0662 9.23862 24.2234 10.6372 25.5622C12.0531 26.9175 14.361 26.9175 15.7769 25.5622L23.2296 18.4283C25.4277 16.3243 25.4277 12.9262 23.2296 10.8222C21.0141 8.70155 17.41 8.70155 15.1946 10.8222L9.18955 16.5703C8.90897 16.8389 8.4638 16.8292 8.19523 16.5486C7.92666 16.268 7.93639 15.8228 8.21697 15.5543L14.222 9.80614Z" fill="#EE0033"/>
              </svg>
            </button>
            <input #fileInput type="file" hidden (change)="onFileSelected($event)" multiple accept=".pdf,.jpg,.png,.bmp,.msg,.eml,.rtf,.doc,.docx,.xls,.xlsx,.jpeg"/>
          </div>
          <div class="send-message-container">
            <div class="w-full">
              <!-- File đính kèm -->
              <div *ngIf="fileList.length > 0" class="attached-files px-2 mb-2 d-flex overflow-auto custom-scrollbar">
                <div *ngFor="let file of fileList; let i = index" class="file-preview d-flex align-items-center p-2 mb-2 rounded">
                  <svg viewBox="0 0 36 36" class="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq xfx01vb" fill="currentColor" height="24" width="24" style="--color: var(--primary-icon);"><path clip-rule="evenodd" d="M18 8c0-.6-.4-1-1-1h-6a2 2 0 00-2 2v18c0 1.1.9 2 2 2h14a2 2 0 002-2V17c0-.6-.4-1-1-1h-4a4 4 0 01-4-4V8zm-6 7c0-.6.4-1 1-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3.5a1 1 0 100 2h10a1 1 0 100-2H13zm0 4.5a1 1 0 100 2h10a1 1 0 100-2H13z" fill-rule="evenodd"></path><path d="M22 14h4a1 1 0 00.7-1.7l-5-5A1 1 0 0020 8v4c0 1.1.9 2 2 2z"></path></svg>
                  <span matTooltip="{{ file.name }}" class="file-name">{{ truncateFileName(file.name) }}</span>
                  <button mat-icon-button (click)="removeFile(i)" class="ms-1 btn-remove-file"><mat-icon>close</mat-icon></button>
                </div>
              </div>
            </div>
            <div class="w-full d-flex align-items-center">
              <textarea #textAreaRef matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="3" [(ngModel)]="newMessage" maxlength="1000" rows="1"  (keydown.enter)="onKeyDown($event)" placeholder="{{'negotiate_contract.chat.hinttext' | translate}}" class="mx-2 input-send-message custom-scrollbar" autocomplete="off"></textarea>
              <button mat-icon-button (click)="sendMessage()" [disabled]="!newMessage.trim() && fileList.length === 0" class="btn-send-message" matTooltip="{{ 'negotiate_contract.chat.submit_comment' | translate }}">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path [ngStyle]="{stroke: !newMessage.trim() && fileList.length === 0 ? 'rgb(181, 180, 180)' : '#CE002B' }" d="M20.5056 10.7754C21.1225 10.5355 21.431 10.4155 21.5176 10.2459C21.5926 10.099 21.5903 9.92446 21.5115 9.77954C21.4205 9.61226 21.109 9.50044 20.486 9.2768L4.59629 3.5728C4.0866 3.38983 3.83175 3.29835 3.66514 3.35605C3.52029 3.40621 3.40645 3.52004 3.35629 3.6649C3.29859 3.8315 3.39008 4.08635 3.57304 4.59605L9.277 20.4858C9.50064 21.1088 9.61246 21.4203 9.77973 21.5113C9.92465 21.5901 10.0991 21.5924 10.2461 21.5174C10.4157 21.4308 10.5356 21.1223 10.7756 20.5054L13.3724 13.8278C13.4194 13.707 13.4429 13.6466 13.4792 13.5957C13.5114 13.5506 13.5508 13.5112 13.5959 13.479C13.6468 13.4427 13.7072 13.4192 13.828 13.3722L20.5056 10.7754Z" stroke="#B5B4B4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-expansion-panel> 
  <hr *ngIf="isNegotiate">
  <!-- Thông tin tài liệu -->
  <mat-expansion-panel expanded="true" class="mat-elevation-z0">
    <mat-expansion-panel-header>
      <mat-panel-title class="document_info mat-panel-title">
        {{'title.view_document_info' | translate}} {{document.code}}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <nz-table [nzShowPagination]=false class="ant-table-no-border">
      <tbody>
        <tr>
          <td style="width: 180px;">{{'form.doc_code' | translate}}</td>
          <td class="font-weight-bold">{{document.code}}</td>
        </tr>
        <tr>
          <td>{{'form.doc_name' | translate}}</td>
          <td class="font-weight-bold">{{document.name}}</td>
        </tr>
        <tr *ngIf="!isNotAttestedUser">
          <td>{{'contract_lot.identify_contract_BCT' | translate}}</td>
          <td class="font-weight-bold" *ngIf="document.isConfirmBCT">{{'contract_lot.is_confirm_BCT' | translate}}</td>
          <td class="font-weight-bold" *ngIf="!document.isConfirmBCT">{{'contract_lot.is_not_confirm_BCT' | translate}}
          </td>
        </tr>
        <tr *ngIf="document.expiredDate">
          <td>{{'form.expired_date' | translate}}</td>
          <td class="font-weight-bold">{{document.expiredDate | date: 'dd/MM/yyyy'}}</td>
        </tr>
        <tr>
          <td>{{'form.status' | translate}}</td>
          <td>
            <nz-tag *ngIf="document.status == enumContractStatus.DRAFT">{{'search_form.draft' | translate}}</nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.PROCESSING && !isSetSignFlow" [nzColor]="'blue'">
              {{'search_form.processing' | translate}}</nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.REJECTED" [nzColor]="'red'">
              {{'search_form.denied_sign' | translate}}</nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.FINISHED && document.contractTerminationStatus !== 2 && document.contractTerminationStatus !== 4" [nzColor]="'green'">
              {{'search_form.finish' | translate}}</nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.CANCELLED" [nzColor]="'red'">
              {{'search_form.cancelled' | translate}}</nz-tag>
            <nz-tag *ngIf="(document.status == enumContractStatus.PROCESSING && isSetSignFlow)" [nzColor]="'orange'">
              {{'search_form.waiting_for_flow' | translate}}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.CONNECTING" [nzColor]="'blue'">
              {{'search_form.connecting' | translate}}</nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT" [nzColor]="'orange'">
              {{ "search_form.wait_confirm_enterprice_no_moit" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.FINISHED && document.contractTerminationStatus == 2" [nzColor]="'blue'">
              {{'contract_terminate.terminating' | translate}}
            </nz-tag>
            <nz-tag *ngIf="document.status == enumContractStatus.FINISHED && document.contractTerminationStatus == 4" [nzColor]="'green'">
              {{'contract_terminate.terminated' | translate}}
            </nz-tag>
          </td>
        </tr>
        <tr *ngIf="document.summary">
          <td>{{ "form.contract_summary" | translate }}</td>
          <td><div class="summaryText">{{  document.summary }}</div></td>
        </tr>
        <tr
          *ngIf="document.isConfirmBCT && document.status == enumContractStatus.FINISHED && cecaEnable && !isNotAttestedUser">
          <td>{{ "ceca.lb_moit_status" | translate }}</td>
          <td>
            <nz-tag *ngIf="document.bctConfirmStatus == enumContractStatus.DRAFT" [nzColor]="'blue'">
              {{ "search_form.processing" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.bctConfirmStatus == enumContractStatus.REJECTED" [nzColor]="'red'">
              {{ "search_form.rejected" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.bctConfirmStatus == enumContractStatus.FINISHED" [nzColor]="'green'">
              {{ "search_form.finish" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.bctConfirmStatus == enumContractStatus.CANCELLED" [nzColor]="'red'">
              {{ "search_form.cancelled" | translate }}
            </nz-tag>
            <nz-tag *ngIf="document.bctConfirmStatus == enumContractStatus.PROCESSING" [nzColor]="'blue'">
              {{ "search_form.processing" | translate }}
            </nz-tag>
          </td>
        </tr>
        <tr *ngIf="document.status == enumContractStatus.PROCESSING && document.processDate">
          <td>{{'form.processing_term' | translate}}</td>
          <td class="font-weight-bold">{{document.processDate | date: 'HH:mm dd/MM/yyyy'}}</td>
        </tr>
      </tbody>
    </nz-table>
  </mat-expansion-panel>

  <hr
    *ngIf="document && (document.contractAttachments.length > 0 ||  document.newUploadContractAttachments.length > 0) && !permissionContractShare">
  <!-- Danh sách tệp đính kèm -->
  <!-- BEGIN: Updated for change request SCONTRACT-5260 and reverted previous version-->
  <mat-expansion-panel class="mat-elevation-z0" expanded="false"
    *ngIf="document && (document.contractAttachments.length > 0 ||  document.newUploadContractAttachments.length > 0) && !permissionContractShare">
    <!-- <hr> -->
    <mat-expansion-panel-header>
      <mat-panel-title class="document_info mat-panel-title">
        {{'form.attach_file_list' | translate}}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <!-- Customer's attachments -->
    <div class="mt-2 fix-width" *ngFor="let item of document.contractAttachments">
      <a (click)="downloadFile(item.id, item.fileName)">
        <em class="fa fa-download fa-fw text-primary" matTooltip="{{'tooltips.download' | translate}}"></em>
        <span [matTooltip]="item.fileName"> {{item.fileName}}</span>
      </a>
    </div>
    <!-- New uploads -->
    <div class="mt-2 fix-width" *ngFor="let item of document.newUploadContractAttachments">
      <a (click)="downloadFile(item.id, item.fileName)">
        <em class="fa fa-download fa-fw text-primary" matTooltip="{{'tooltips.download' | translate}}"></em>
        <span [matTooltip]="item.fileName"> {{item.fileName}}</span>
      </a>
    </div>
    <span style="color:#858796; font-size: 14px;"
      *ngIf="document && document.contractAttachments.length == 0 && document.newUploadContractAttachments.length == 0">
      {{'form.document_not_found' | translate}}
    </span>
    <!-- <hr /> -->
  </mat-expansion-panel>
  <!-- END: Updated for change request SCONTRACT-5260 -->
  <hr>
  <!-- Luồng trình tự các bên Chủ thể -->
  <!-- <mat-expansion-panel expanded="true" class="mat-elevation-z0" *ngIf="!isSetSignFlow"> -->
  <mat-expansion-panel class="mat-elevation-z0" expanded="true" *ngIf="document.parents && document.parents.length > 0 && !permissionContractShare">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "form.digital_contract.document_parent" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element">
      <nz-table #editRowInternalTable nzBordered [nzData]="document.parents" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
        <thead>
        <tr>
          <th class="text-center" nzWidth="25px">
            {{
            "enterprise_contract.panel_document.table_users.header.order"
            | translate
            }}
          </th>
          <th class="text-center" nzWidth="80%">
            {{
            "form.digital_contract.document_information"
            | translate
            }}
          </th>
          <th class="text-center">
            <!--                        {{-->
            <!--                          "enterprise_contract.panel_document.table_users.header.action"-->
            <!--                            | translate-->
            <!--                        }}-->
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of editRowInternalTable.data; let i = index" class="editable-row">
          <!-- TT -->
          <td class="text-center">{{ i + 1 }}</td>
          <!-- Tên -->
          <td class="word-break-line">
            <div class="editable-cell">
              <div class="row-icon"> {{ data.code }}
                - {{ data.name }}
              </div>
            </div>
          </td>
          <!-- Action -->
          <td class="td-nz-icon text-center">
            <button mat-icon-button (click)="viewContract(data)" *ngIf="data.id " aria-label="View" style="color: #07736C">
              <mat-icon>
                visibility
              </mat-icon>
            </button>
          </td>
        </tr>
        </tbody>
      </nz-table>
      <ng-template #contentEmptyTable ></ng-template>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel class="mat-elevation-z0" expanded="true" *ngIf="document.contractTerminations && document.contractTerminations.length > 0">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ (document.formType == "CONTRACT_TERMINATION" ? "contract_terminate.contract_liquidated" : "contract_terminate.terminate") | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element">
      <nz-table #contractTerminationsTable nzBordered [nzData]="document.contractTerminations" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable"
                [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
        <thead>
        <tr>
          <th class="text-center" nzWidth="25px">
            {{
              "enterprise_contract.panel_document.table_users.header.order"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="75%">
            {{
              "form.digital_contract.document_information"
                | translate
            }}
          </th>
          <th class="text-center">
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of contractTerminationsTable.data; let i = index" class="editable-row">
          <!-- TT -->
          <td class="text-center">{{ i + 1 }}</td>
          <!-- Tên -->
          <td class="word-break-line">
            <div class="editable-cell d-flex align-items-center">
              <div class="row-icon">
                <span>{{ data.code }} - {{ data.name }}</span>
              </div>
            </div>
          </td>
          <td class="td-nz-icon text-center">
            <button mat-icon-button (click)="viewContract(data)" *ngIf="data.id" aria-label="View" style="color: #07736C">
              <mat-icon>
                visibility
              </mat-icon>
            </button>
          </td>
        </tr>
        </tbody>
      </nz-table>
      <ng-template #contentEmptyTable ></ng-template>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel expanded="true" class="mat-elevation-z0">

    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{'form.contracting_parties' | translate}}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-enterprise-element" *ngIf="!isSetUpSignFlow">
      <nz-table #expandTable nzBordered [nzData]="listOfMapData" [nzShowPagination]=false
        class="ant-table-no-placeholder-border-bottom">
        <thead>
          <tr>
            <th nzWidth="40px" class="text-center">
              {{ 'enterprise_contract.panel_document_view.table_signing_flow.header.order' | translate}}</th>
            <th>{{ 'enterprise_contract.panel_document_view.table_signing_flow.header.party_name' | translate}}</th>
            <th nzWidth="25%" class="text-center">
              {{ 'enterprise_contract.panel_document_view.table_signing_flow.header.progress' | translate}}</th>
            <th nzWidth="25px"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let data of expandTable.data">
            <ng-container *ngFor="let item of mapOfExpandedData[data.key]">
              <tr
                *ngIf="(item.type == enumContractDetailType.ENTERPRISE) && ((item.parent && item.parent.expand) || !item.parent)"
                class="tr-enterprise-data">
                <td class="text-center">{{ item.order }}</td>
                <td class="enterprise-name">{{ item.name }}</td>
                <td style="position: relative;" class="text-center">
                  <nz-tag *ngIf="item.status == enumContractEnterpriseStatus.NO_PROCESS">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.waiting' |
                    translate}}
                  </nz-tag>
                  <nz-tag [nzColor]="'blue'"
                    *ngIf="(document.status != enumContractStatus.REJECTED && document.status != enumContractStatus.CANCELLED)
                          && (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW)">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="(document.status === enumContractStatus.REJECTED || document.status === enumContractStatus.CANCELLED)
                          && (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW)
                          && !item.showNoFlowNotification">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress' |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="(document.status === enumContractStatus.REJECTED || document.status === enumContractStatus.CANCELLED)
                          && (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW)
                          && item.showNoFlowNotification">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress' |
                    translate}}
                  </nz-tag>
                  <nz-tag [nzColor]="'red'" *ngIf="item.status == enumContractEnterpriseStatus.REJECTED">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.denied' |
                    translate}}
                  </nz-tag>
                  <nz-tag [nzColor]="'green'" *ngIf="item.status == enumContractEnterpriseStatus.SIGNED">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.signed' |
                    translate}}
                  </nz-tag>
                  <nz-tag [nzColor]="'red'" *ngIf="item.status == enumContractEnterpriseStatus.CANCELLED">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.cancel_flow' |
                    translate}}
                  </nz-tag>

                  <nz-tag *ngIf="(document.status !== enumContractStatus.REJECTED && document.status !== enumContractStatus.CANCELLED)
                          && (item.status == enumContractEnterpriseStatus.DAEMON_PROCESSING)">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.daemon_processing' |
                    translate}}
                  </nz-tag>

                  <div *ngIf="!isNotAttestedUser" style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%);">
                    <div
                      *ngIf="item.identityStatus == 1 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_OTP' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 2 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_viettel' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 3 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_refused' | translate}}">
                        <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 4 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_pending_OTP' | translate}}">
                        <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                  <!-- <nz-tag [nzColor]="'orange'"
                        *ngIf="(item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) && item.showNoFlowNotification">{{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' | translate}}</nz-tag>
                <nz-tag [nzColor]="'blue'"
                        *ngIf="(item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) && !item.showNoFlowNotification">{{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' | translate}}</nz-tag> -->
                </td>
                <td [nzShowExpand]="!!item.children" [(nzExpand)]="item.expand"
                  (nzExpandChange)="collapse(mapOfExpandedData[data.key], item, $event)"></td>
              </tr>
              <tr
                *ngIf="(item.type == enumContractDetailType.USER) && ((item.parent && item.parent.expand) || !item.parent)"
                class="tr-user-data">
                <td></td>
                <td>{{ item.order }}. {{ item.name }}</td>
                <td style="position: relative;" class="text-center">
                  <nz-tag *ngIf="item.status == enumContractUserStatus.NO_PROCESS">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.user_status.waiting' | translate}}
                  </nz-tag>
                  <nz-tag [nzColor]="'blue'"
                    *ngIf="document.status != enumContractStatus.REJECTED && item.status == enumContractUserStatus.PROCESSING">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.user_status.processing' | translate}}
                  </nz-tag>
                  <nz-tag
                    *ngIf="document.status === enumContractStatus.REJECTED && item.status == enumContractUserStatus.PROCESSING">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.user_status.stop_progress' |
                    translate}}
                  </nz-tag>
                  <nz-tag [nzColor]="'red'" *ngIf="item.status == enumContractUserStatus.REJECTED">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.user_status.denied' | translate}}
                  </nz-tag>
                  <nz-tag [nzColor]="'green'"
                    *ngIf="item.status == enumContractUserStatus.PROCESSED && item.role == enumContractUserRole.APPROVE">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.user_status.approved' | translate}}
                  </nz-tag>
                  <nz-tag [nzColor]="'green'"
                    *ngIf="item.status == enumContractUserStatus.PROCESSED && item.role == enumContractUserRole.SIGN">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.user_status.signed' | translate}}
                  </nz-tag>
                  <nz-tag [nzColor]="'red'" *ngIf="item.status == enumContractUserStatus.CANCELLED">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.user_status.cancel_flow' |
                    translate}}
                  </nz-tag>

                  <div style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%);">
                    <div
                      *ngIf="item.identityStatus == 1 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_OTP' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 2 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                      <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_success_viettel' | translate}}">
                        <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 3 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_refused' | translate}}">
                        <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>
                      </div>
                    </div>
                    <div
                      *ngIf="item.identityStatus == 4 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                      <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                        nzTooltipTitle="{{'enterprise_contract.status_pending_OTP' | translate}}">
                        <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </td>
                <td [nzShowExpand]="!!item.children" [(nzExpand)]="item.expand"
                  (nzExpandChange)="collapse(mapOfExpandedData[data.key], item, $event)"></td>
              </tr>
              <tr
                *ngIf="(item.type == enumContractDetailType.DETAIL) && !item.showNoFlowNotification && ((item.parent && item.parent.expand) || !item.parent)">
                <td></td>
                <td colspan="2" class="td-detail-data">
                  <ng-container
                    *ngIf="item.identityStatus == 1 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: <span class="ml-1" style="color: green;">{{'enterprise_contract.status_success_OTP' |
                        translate}}</span>
                    </div>
                    <!-- <div *ngIf="isNotAttestedUser">
                      {{'enterprise_contract.info_status_not_attested' | translate}}: <span class="ml-1"
                        style="color: green;">{{'enterprise_contract.status_success_verify_subject' |
                        translate}}</span>
                    </div> -->
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 2 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: <span class="ml-1"
                        style="color: green;">{{'enterprise_contract.status_success_viettel' | translate}}</span>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 3 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: <span class="ml-1" style="color: red;">{{'enterprise_contract.status_refused' |
                        translate}}</span>
                    </div>
                    <!-- <div *ngIf="isNotAttestedUser">
                      {{'enterprise_contract.info_status_not_attested' | translate}}: <span class="ml-1"
                        style="color: red;">{{'enterprise_contract.status_refused_verify_subject' |
                        translate}}</span>
                    </div> -->
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 3 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                    <div>
                      <span>{{'enterprise_contract.reason_for_refusal' | translate}}: {{item.identityReason}}</span>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="item.identityStatus == 4 && (data.enterpriseId == enterpriseIdSignInFlow || checkUSerCreateContract)">
                    <div *ngIf="!isNotAttestedUser">
                      {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                      translate}}: {{'enterprise_contract.status_pending_OTP' | translate}}
                    </div>
                    <!-- <div *ngIf="isNotAttestedUser">
                      {{'enterprise_contract.info_status_not_attested' | translate}}:
                      {{'enterprise_contract.status_pending_verify_subject' | translate}}
                    </div> -->
                  </ng-container>
                  <span *ngIf="item.role">{{
                    'enterprise_contract.panel_document_view.table_signing_flow.detail_content.role' | translate}}
                    :
                    {{ (item.role == roleUser.CANCEL) ?
                    ('enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_cancel' |
                    translate)
                    : ((item.role == roleUser.SIGN) ?
                    ('enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_sign' | translate)
                    : ('enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_approve' |
                    translate)) }}<br /></span>
                  <span *ngIf="item.comment">{{
                    'enterprise_contract.panel_document_view.table_signing_flow.detail_content.content' | translate}}
                    : {{item.comment}}<br /></span>
                  <span
                    *ngIf="item.time && (item.status == enumContractUserStatus.REJECTED || item.status == enumContractUserStatus.PROCESSED)">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.time' | translate}}:
                    {{item.time | dateformat}}<br /></span>
                  <span *ngIf="item.certificateNo && !hiddenCerrtificateNo(item.certificateNo)">{{
                    'enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no' |
                    translate}}
                    : {{item.certificateNo}}<br /></span>
                  <span *ngIf="item.contact">{{
                    'enterprise_contract.panel_document_view.table_signing_flow.detail_content.contact' | translate}}
                    : {{item.contact}}<br /></span>
                  <span *ngIf="item.isSignedAnonymous && item.status == enumContractUserStatus.REJECTED">
                    {{
                    'enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_reject_by_email' |
                    translate}}<br /></span>
                  <span *ngIf="item.isSignedAnonymous && item.status == enumContractUserStatus.PROCESSED">
                    {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_sign_by_email'
                    | translate}}<br /></span>
                  <span
                    *ngIf="item.establishSignNoLogin && (!(item.status == enumContractUserStatus.REJECTED || item.status == enumContractUserStatus.PROCESSED))">
                    {{
                    'enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_establish_sign_by_email'
                    | translate}}<br /></span>
                  <!-- Thông tin ký -->
                  <div *ngIf="item.signMethod != null && item.status == enumContractUserStatus.PROCESSED">
                    <span>{{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_info" |
                      translate}}: </span>

                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.SIGN_USB_TOKEN">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_usb_token" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.SIGN_SIM_CA">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_sim_ca" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.SIGN_OTP">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.SIGN_SERVER">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_hsm" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.SIGN_IMAGE">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_image" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.SIGN_OTP_EKYC">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.SIGN_OTP_EKYC_ADVANCED">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc_advanced"
                      | translate}}
                    </span>
                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.SIGN_NO_CERT">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.CLOUD_CA">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_cloud_ca" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.VNEID">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_vneid" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf=" item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                    || item.signMethod == enumSignMethod.SIGN_SIM_CA
                    || item.signMethod == enumSignMethod.SIGN_SERVER
                    || item.signMethod == enumSignMethod.VNEID
                    || item.signMethod == enumSignMethod.CLOUD_CA)">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.issued_to" |
                      translate}}:
                      {{ item.signMetadata.issuedTo }}
                    </span>
                    <span class="ml-2" *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                    || item.signMethod == enumSignMethod.SIGN_SIM_CA
                    || item.signMethod == enumSignMethod.SIGN_SERVER
                    || item.signMethod == enumSignMethod.VNEID
                    || item.signMethod == enumSignMethod.CLOUD_CA)">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.serial_number" |
                      translate}}:
                      {{ item.signMetadata.serialNumber }}
                    </span>
                    <span class="ml-2" *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                    || item.signMethod == enumSignMethod.SIGN_SIM_CA
                    || item.signMethod == enumSignMethod.SIGN_SERVER
                    || item.signMethod == enumSignMethod.VNEID
                    || item.signMethod == enumSignMethod.CLOUD_CA)">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no" |
                      translate}}:
                      {{ item.signMetadata.certificateNo }}
                    </span>
                    <span class="ml-2"
                      *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_OTP || item.signMethod == enumSignMethod.SIGN_SIM_CA)
                      || item.signMethod == enumSignMethod.SIGN_OTP_EKYC_ADVANCED || item.signMethod == enumSignMethod.SIGN_OTP_EKYC">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.phone_number" |
                      translate}}:
                      {{ item.signMetadata.phoneNumber }}
                    </span>
                  </div>
                  <!-- END of Thông tin ký -->
                </td>
                <td>&nbsp;</td>
              </tr>
              <tr
                *ngIf="(item.type == enumContractDetailType.DETAIL) && item.showNoFlowNotification && ((item.parent && item.parent.expand) || !item.parent)">
                <td></td>
                <!--                <td colspan="2" class="td-detail-data" *ngIf="document.status != enumContractStatus.REJECTED">-->
                <!--                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.wait_setup_flow' | translate}}-->
                <!--                </td>-->
                <td colspan="2" class="td-detail-data" *ngIf="document.status === enumContractStatus.REJECTED">
                  {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.partner_refuse' |
                  translate}}
                </td>
                <td>&nbsp;</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </nz-table>
    </div>
    <div class="table-enterprise-element" *ngIf="isSetUpSignFlow">
      <nz-table #expandTable [nzData]="listOfMapData" [nzFrontPagination]="false" [nzShowPagination]="false"
                class="ant-table-no-placeholder-border-bottom" nzBordered>
        <thead>
        <tr>
          <th class="text-center" nzWidth="40px">
            {{
            "enterprise_contract.panel_document_view.table_signing_flow.header.order"
              | translate
            }}
          </th>
          <th>
            {{
            "enterprise_contract.panel_document_view.table_signing_flow.header.party_name"
              | translate
            }}
          </th>
          <th nzWidth="25%" class="text-center">
            {{
            "enterprise_contract.panel_document_view.table_signing_flow.header.progress"
              | translate
            }}
          </th>
          <th nzWidth="25px"></th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let data of expandTable.data">
          <ng-container *ngFor="let item of mapOfExpandedData[data.key]">
            <tr
              *ngIf=" item.type == enumContractDetailType.ENTERPRISE && ((item.parent && item.parent.expand) || !item.parent)"
              class="tr-enterprise-data">
              <td class="text-center">{{ item.order }}</td>
              <td class="enterprise-name">{{ item.name }}</td>
              <td style="position: relative;" class="text-center">
                <nz-tag *ngIf=" item.status == enumContractEnterpriseStatus.NO_PROCESS">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.waiting" |
                  translate}}
                </nz-tag>
                <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                                 document.status != enumContractStatus.CANCELLED &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 !item.showNoFlowNotification" [nzColor]="'blue'">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing" |
                  translate}}
                </nz-tag>
                <nz-tag *ngIf="(document.status === enumContractStatus.REJECTED || document.status === enumContractStatus.CANCELLED) &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 !item.showNoFlowNotification">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress" |
                  translate}}
                </nz-tag>
                <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                                 document.status != enumContractStatus.CANCELLED &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 item.showNoFlowNotification" [nzColor]="'orange'">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow" |
                  translate}}
                </nz-tag>
                <nz-tag *ngIf="(document.status === enumContractStatus.REJECTED || document.status === enumContractStatus.CANCELLED) &&
                                 (item.status == enumContractEnterpriseStatus.PROCESSING || item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) &&
                                 item.showNoFlowNotification">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress" |
                  translate}}
                </nz-tag>
                <nz-tag *ngIf="item.status == enumContractEnterpriseStatus.REJECTED" [nzColor]="'red'">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.denied" |
                  translate}}
                </nz-tag>
                <nz-tag *ngIf="item.status == enumContractEnterpriseStatus.SIGNED" [nzColor]="'green'">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.signed" |
                  translate}}
                </nz-tag>
                <nz-tag *ngIf="item.status == enumContractEnterpriseStatus.CANCELLED" [nzColor]="'red'">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.cancel_flow" |
                  translate}}
                </nz-tag>

                <nz-tag *ngIf="document.status != enumContractStatus.REJECTED &&
                                 document.status != enumContractStatus.CANCELLED &&
                                 (item.status == enumContractEnterpriseStatus.DAEMON_PROCESSING)" [nzColor]="'orange'">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.daemon_processing" |
                  translate}}
                </nz-tag>

                <div *ngIf="!isNotAttestedUser"
                     style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%);">
                  <div
                    *ngIf="item.identityStatus == 1 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                         nzTooltipTitle="{{'enterprise_contract.status_success_OTP' | translate}}">
                      <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                    </div>
                  </div>
                  <div
                    *ngIf="item.identityStatus == 2 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                         nzTooltipTitle="{{'enterprise_contract.status_success_viettel' | translate}}">
                      <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                    </div>
                  </div>
                  <div
                    *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                         nzTooltipTitle="{{'enterprise_contract.status_refused' | translate}}">
                      <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>
                    </div>
                  </div>
                  <div
                    *ngIf="item.identityStatus == 4 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                         nzTooltipTitle="{{'enterprise_contract.status_pending_OTP' | translate}}">
                      <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
                <!-- <nz-tag [nzColor]="'orange'"
                  *ngIf="(item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) && item.showNoFlowNotification">{{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.wait_setup_flow' | translate}}</nz-tag>
          <nz-tag [nzColor]="'blue'"
                  *ngIf="(item.status == enumContractEnterpriseStatus.WAIT_SETUP_FLOW) && !item.showNoFlowNotification">{{ 'enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.processing' | translate}}</nz-tag> -->
              </td>
              <td (nzExpandChange)="collapse(mapOfExpandedData[data.key], item, $event)" [(nzExpand)]="item.expand"
                  [nzShowExpand]="!!item.children">
              </td>
            </tr>
            <tr
              *ngIf="item.type == enumContractDetailType.USER && ((item.parent && item.parent.expand) || !item.parent)"
              class="tr-user-data">
              <td></td>
              <td>{{ item.order }}. {{ item.name }} <span
                *ngIf="item.departmentName">({{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.representative_name"
                | translate}} {{item.departmentName}}
                )</span>
                <span *ngIf="(item.role == 2 ||item.role == 7) && item.isSignDigitalCertificate">
                    <img src="assets/images/certificate-diploma3.svg"
                         title="{{ 'enterprise_contract.panel_document.table_parties.header.tooltip_sig_cts' | translate }}"
                         style="width: 16px; height: 16px;">
                  </span>
              </td>
              <td style="position: relative;" class="text-center">
                <nz-tag *ngIf="item.status == enumContractUserStatus.NO_PROCESS">
                  <!--                    <div *ngIf="item.role == enumContractUserRole.APPROVE">-->
                  <!--                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approving_process" | translate}}-->
                  <!--                    </div>-->
                  <!--                    <div *ngIf="item.role == enumContractUserRole.SIGN">-->
                  <!--                      {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.signing_process" | translate}}-->
                  <!--                    </div>-->
                  <!--                    <div *ngIf="item.role == enumContractUserRole.INITIAL">-->
                  <!--                      {{"enterprise_contract.pan el_document_view.table_signing_flow.user_status.initialling_process" | translate}}-->
                  <!--                    </div>-->
                  <div>
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.waiting" | translate}}
                  </div>
                </nz-tag>
                <nz-tag *ngIf="
                      document.status != enumContractStatus.REJECTED &&
                      document.status != enumContractStatus.CANCELLED &&
                      item.status == enumContractUserStatus.PROCESSING" [nzColor]="'blue'">
                  <div *ngIf="item.role == enumContractUserRole.APPROVE || item.role == 7">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approving" | translate}}
                  </div>
                  <div *ngIf="item.role == enumContractUserRole.SIGN || item.role == 6">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.signing" | translate}}
                  </div>
                  <div *ngIf="item.role == enumContractUserRole.INITIAL">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling" |
                    translate}}
                  </div>
                </nz-tag>

                <nz-tag *ngIf="
                      document.status != enumContractStatus.REJECTED &&
                      document.status != enumContractStatus.CANCELLED &&
                      item.status == enumContractUserStatus.DAEMON_PROCESSING" [nzColor]="'orange'">
                  <div *ngIf="item.role == enumContractUserRole.APPROVE">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approving" | translate}}
                  </div>
                  <div *ngIf="item.role == enumContractUserRole.SIGN">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.daemon_processing" | translate}}
                  </div>
                  <div *ngIf="item.role == enumContractUserRole.INITIAL">
                    {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.initialling" |
                    translate}}
                  </div>
                </nz-tag>

                <nz-tag *ngIf="
                      ((document.status === enumContractStatus.REJECTED ||
                        document.status === enumContractStatus.CANCELLED) &&
                      item.status == enumContractUserStatus.PROCESSING) || item.status === 0">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.stop_progress" |
                  translate}}
                </nz-tag>
                <nz-tag *ngIf="item.status == enumContractUserStatus.REJECTED" [nzColor]="'red'">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.denied" | translate}}
                </nz-tag>
                <nz-tag *ngIf="item.status == enumContractUserStatus.PROCESSED &&
                     ( item.role == enumContractUserRole.APPROVE || item.role == 7 )" [nzColor]="'green'">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.approved" | translate}}
                </nz-tag>
                <nz-tag *ngIf="item.status == enumContractUserStatus.PROCESSED &&
                                 ( item.role == enumContractUserRole.SIGN || item.role == 6 )" [nzColor]="'green'">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.signed" | translate}}
                </nz-tag>
                <nz-tag *ngIf="item.status == enumContractUserStatus.CANCELLED" [nzColor]="'red'">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.user_status.cancel_flow" | translate}}
                </nz-tag>
                <div style="position: absolute; right: 4px; top: 50%; transform: translateY(-50%);">
                  <div
                    *ngIf="item.identityStatus == 1 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                         nzTooltipTitle="{{'enterprise_contract.status_success_OTP' | translate}}">
                      <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                    </div>
                  </div>
                  <div
                    *ngIf="item.identityStatus == 2 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div style="font-size: 18px;" class="d-flex align-items-center" nz-tooltip
                         nzTooltipTitle="{{'enterprise_contract.status_success_viettel' | translate}}">
                      <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                    </div>
                  </div>
                  <div
                    *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                         nzTooltipTitle="{{'enterprise_contract.status_refused' | translate}}">
                      <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>
                    </div>
                  </div>
                  <div
                    *ngIf="item.identityStatus == 4 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                    <div style="font-size: 16px;" class="d-flex align-items-center ml-1" nz-tooltip
                         nzTooltipTitle="{{'enterprise_contract.status_pending_OTP' | translate}}">
                      <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </td>
              <td (nzExpandChange)="collapse(mapOfExpandedData[data.key], item, $event)" [(nzExpand)]="item.expand"
                  [nzShowExpand]="!!item.children">
              </td>
            </tr>
            <tr *ngIf="
                  item.type == enumContractDetailType.DETAIL &&
                  !item.showNoFlowNotification &&
                  ((item.parent && item.parent.expand) || !item.parent)
                ">
              <td></td>
              <td class="td-detail-data" colspan="2">
                <ng-container
                  *ngIf="item.identityStatus == 1 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                  <div *ngIf="!isNotAttestedUser">
                    {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                    translate}}: <span class="ml-1" style="color: green;">{{'enterprise_contract.status_success_OTP' |
                    translate}}</span>
                  </div>
                  <!-- <div *ngIf="isNotAttestedUser">
                    {{'enterprise_contract.info_status_not_attested' | translate}}: <span class="ml-1"
                      style="color: green;">{{'enterprise_contract.status_success_verify_subject' |
                      translate}}</span>
                  </div> -->
                </ng-container>
                <ng-container
                  *ngIf="item.identityStatus == 2 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                  <div *ngIf="!isNotAttestedUser">
                    {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                    translate}}: <span class="ml-1"
                                       style="color: green;">{{'enterprise_contract.status_success_viettel' | translate}}</span>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                  <div *ngIf="!isNotAttestedUser">
                    {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                    translate}}: <span class="ml-1" style="color: red;">{{'enterprise_contract.status_refused' |
                    translate}}</span>
                  </div>
                  <div *ngIf="isNotAttestedUser" style="padding-bottom: 0.5rem;">
                    {{'enterprise_contract.info_status_not_attested' | translate}}: <span class="ml-1"
                                                                                          style="color: red;">{{'enterprise_contract.status_refused_verify_subject' |
                    translate}}</span>
                  </div>
                </ng-container>
                <ng-container
                  *ngIf="(item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract))"
                >
                  <span class="refusal">{{'enterprise_contract.panel_document_view.table_signing_flow.detail_content.content' | translate}}: {{item.identityReason }}</span>
                </ng-container>
                <span *ngIf="item.reasonUserApprove && item.status == 3">{{'enterprise_contract.panel_document_view.table_signing_flow.detail_content.content' | translate}}: {{item.reasonUserApprove}}
                  <br /></span>
                <span *ngIf="item.reasonApprove && item.status == 4">{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.content"
                    | translate
                  }}: {{ item.reasonApprove }}<br /></span>
                <span *ngIf="item.reasonSignUser && item.status == 3">{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.content"
                    | translate
                  }}: {{ item.reasonSignUser }}<br /></span>
                <ng-container
                  class="refusal"
                  *ngIf="item.time && item.identityStatus == 3 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)"
                >
                  <span class="refusal">{{"enterprise_contract.time_refusal" | translate }}: {{ funcionTime(item.time) ? (item.time | dateformat) : item.time}}</span>
                </ng-container>
                <ng-container
                  *ngIf="item.identityStatus == 4 && (item.enterpriseId == enterpriseId || checkUSerCreateContract)">
                  <div *ngIf="!isNotAttestedUser">
                    {{'enterprise_contract.info_status' | translate}}, {{'enterprise_contract.title_status' |
                    translate}}: {{'enterprise_contract.status_pending_OTP' | translate}}
                  </div>
                  <!-- <div *ngIf="isNotAttestedUser">
                    {{'enterprise_contract.info_status_not_attested' | translate}}:
                    {{'enterprise_contract.status_pending_verify_subject' | translate}}
                  </div> -->
                </ng-container>
                <span *ngIf="item.role">{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.role"
                    | translate
                  }}: {{
                  item.role == roleUser.CANCEL
                    ? ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_cancel"
                      | translate)
                    : item.role == roleUser.SIGN
                    ? ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_sign"
                      | translate)
                    : ("enterprise_contract.panel_document_view.table_signing_flow.detail_content.role_approve"
                      | translate)
                  }}
                  <br /></span>
                <span *ngIf="(item.role == 2 || item.role == 7) && item.isSignDigitalCertificate && !item?.signConfig?.showImage">{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.approve_type"
                    | translate
                  }}: {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.info_approve_no_image' | translate }}<br /></span>
                <span *ngIf="(item.role == 2 || item.role == 7) && item.isSignDigitalCertificate && item?.signConfig?.showImage">{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.approve_type"
                    | translate
                  }}: {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.info_approve_image' | translate }}<br /></span>
                <span *ngIf="item.taxCode">{{
                  "form.taxCode"| translate
                  }}: {{ item.taxCode }}<br /></span>
                <span *ngIf="item.comment">{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.content"
                    | translate
                  }}: {{ item.comment }}<br /></span>
                <span *ngIf="
                      item.time &&
                      (item.status == enumContractUserStatus.REJECTED ||
                        item.status == enumContractUserStatus.PROCESSED)
                    ">{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.time"
                    | translate
                  }}: {{  funcionTime(item.time) ? (item.time | dateformat) : item.time  }}<br /></span>
                <span *ngIf="item.certificateNo && !hiddenCerrtificateNo(item.certificateNo)">{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no"
                    | translate
                  }}: {{ item.certificateNo }}<br /></span>
                <span *ngIf="item.contact">{{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.contact"
                    | translate
                  }}: {{ item.contact }}<br /></span>
                <span *ngIf="
                      item.isSignedAnonymous &&
                      item.status == enumContractUserStatus.REJECTED
                    ">
                    {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_reject_by_email"
                    | translate
                  }}
                  <br /></span>
                <span *ngIf="
                      item.isSignedAnonymous &&
                      item.status == enumContractUserStatus.PROCESSED
                    ">
                    {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_sign_by_email"
                    | translate
                  }}
                  <br /></span>
                <span *ngIf="item.signConfigEnterprise.showImage && !item.isCreatedSide && item.role !=1 && item.enterpriseType != 10000">
                    {{
                  "enterprise_contract.panel_document_view.table_signing_flow.detail_content.notify_establish_sign_by_image"
                    | translate
                  }}
                  <br /></span>

                <!-- Thông tin ký -->
                <span *ngIf="item.signMethod != null && item.status == enumContractUserStatus.PROCESSED">
                    <span>{{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_info" |
                      translate}}
                      :</span>

                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_USB_TOKEN" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_usb_token" |
                        translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_SIM_CA" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_sim_ca" |
                        translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_OTP" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp" |
                        translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_SERVER" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_hsm" |
                        translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_IMAGE" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_image" |
                        translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_NO_CERT" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert" |
                        translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_OTP_EKYC" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc" |
                        translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_OTP_EKYC_ADVANCED" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc_advanced"
                        | translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_NO_CERT_EKYC" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert_ekyc" |
                        translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.SIGN_NO_CERT_EKYC_ADVANCED" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert_ekyc_advanced"
                        | translate}}
                    </span>
                    <span *ngIf="item.signMethod == enumSignMethod.CLOUD_CA" class="ml-2">
                      - {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                      :
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_cloud_ca" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf="item.signMethod == enumSignMethod.VNEID">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_vneid" |
                      translate}}
                    </span>
                    <span *ngIf=" item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA
                        || item.signMethod == enumSignMethod.SIGN_SERVER
                        || item.signMethod == enumSignMethod.VNEID
                        || item.signMethod == enumSignMethod.CLOUD_CA)" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.issued_to" |
                        translate}}
                      :
                      {{ item.signMetadata.issuedTo }}
                    </span>
                    <span *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA
                        || item.signMethod == enumSignMethod.SIGN_SERVER
                        || item.signMethod == enumSignMethod.VNEID
                        || item.signMethod == enumSignMethod.CLOUD_CA)" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.serial_number" |
                        translate}}
                      :
                      {{ item.signMetadata.serialNumber }}
                    </span>
                    <span *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_USB_TOKEN
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA
                        || item.signMethod == enumSignMethod.SIGN_SERVER
                        || item.signMethod == enumSignMethod.VNEID
                        || item.signMethod == enumSignMethod.CLOUD_CA)" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no" |
                        translate}}
                      :
                      {{ item.signMetadata.certificateNo }}
                    </span>
                    <span *ngIf="item.signMetadata && (item.signMethod == enumSignMethod.SIGN_OTP
                        || item.signMethod == enumSignMethod.SIGN_SIM_CA)" class="ml-2">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.phone_number" |
                        translate}}
                      :
                      {{ item.signMetadata.phoneNumber }}
                    </span>
                  </span>
                <!-- END of Thông tin ký -->

              </td>
              <td>&nbsp;</td>
            </tr>
            <tr *ngIf="item.type == enumContractDetailType.DETAIL &&
                  item.showNoFlowNotification &&
                  ((item.parent && item.parent.expand) || !item.parent)
                ">
              <td></td>
              <td *ngIf="document.status != enumContractStatus.REJECTED" class="td-detail-data" colspan="2">
                {{
                "enterprise_contract.panel_document_view.table_signing_flow.detail_content.wait_setup_flow"
                  | translate
                }}
              </td>
              <td *ngIf="document.status === enumContractStatus.REJECTED" class="td-detail-data" colspan="2">
                {{
                "enterprise_contract.panel_document_view.table_signing_flow.detail_content.partner_refuse"
                  | translate
                }}
              </td>
              <td>&nbsp;</td>
            </tr>
          </ng-container>
        </ng-container>
        </tbody>
      </nz-table>
    </div>
  </mat-expansion-panel>
  <hr *ngIf="!isSetUpSignFlow" />
  <!-- Thông tin phê duyệt của đơn vị -->
  <mat-expansion-panel class="mat-elevation-z0" expanded="true" *ngIf="listDataApprover.length && !isSetUpSignFlow">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title">
        {{ "approved.info_approved" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="table-enterprise-element">
      <nz-table #expandTableApprover [nzData]="listDataApprover" [nzFrontPagination]="false" [nzShowPagination]="false"
        class="ant-table-no-placeholder-border-bottom" nzBordered>
        <thead>
          <tr>
            <th class="text-center" nzWidth="40px">
              {{"approved.no" | translate }}
            </th>
            <th>
              {{"approved.approver" | translate}}
            </th>
            <th nzWidth="25%" class="text-center">
              {{"enterprise_contract.panel_document_view.table_signing_flow.header.progress" | translate }}
            </th>
            <th nzWidth="25px"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let data of expandTableApprover.data, index as i">
            <tr>
              <td class="text-center">{{i+1}}</td>
              <td class="font-weight-bold">{{data.fullName}}<span *ngIf=" data.isSignDigitalCertificate">
                    <img src="assets/images/certificate-diploma3.svg"
                         title="{{ 'enterprise_contract.panel_document.table_parties.header.tooltip_sig_cts' | translate }}"
                         style="width: 30px; height: 16px;">
                  </span></td>
              <td class="text-center">
                <nz-tag *ngIf="data?.status == enumApproverStatus.NO_PROCESS">
                  {{"forward_sign.status.no_process" | translate}}
                </nz-tag>
                <nz-tag *ngIf="data?.status == enumApproverStatus.PROCESSED" [nzColor]="'green'">
                  {{"forward_sign.status.processed" | translate}}
                </nz-tag>
                <nz-tag *ngIf="data?.status == enumApproverStatus.PROCESSING" [nzColor]="'blue'">
                  {{"forward_sign.status.processing" | translate}}
                </nz-tag>
                <nz-tag *ngIf="data?.status == enumApproverStatus.REJECTED" [nzColor]="'red'">
                  {{"forward_sign.status.rejected" | translate}}
                </nz-tag>
                <nz-tag *ngIf="data?.status == enumApproverStatus.STOP_PROCESS">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.stop_progress" | translate}}
                </nz-tag>
                <nz-tag *ngIf="data?.status == enumApproverStatus.DAEMON_PROCESSING">
                  {{"enterprise_contract.panel_document_view.table_signing_flow.enterprise_status.daemon_processing" | translate}}
                </nz-tag>
              </td>
              <td nzShowExpand [(nzExpand)]="mapOfExpandData[data.id]"></td>
            </tr>
            <tr [nzExpand]="mapOfExpandData[data.id]">
              <td>&nbsp;</td>
              <td class="td-detail-data" colspan="2">
                <span>Email: {{data.email}}<br /></span>
                <span *ngIf="data.phoneNumber">{{"approved.phone_number" | translate }}: {{data.phoneNumber}} <br /></span>
                <span *ngIf="data.taxCode">{{"form.taxCode" | translate}}: {{data.taxCode}} <br /></span>
                <span *ngIf=" data.isSignDigitalCertificate && !data?.signConfig?.showImage">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.approve_type"
                      | translate
                  }}
                  : {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.info_approve_no_image' | translate }}<br /></span>
                <span *ngIf=" data.isSignDigitalCertificate && data?.signConfig?.showImage">{{
                    "enterprise_contract.panel_document_view.table_signing_flow.detail_content.approve_type"
                      | translate
                  }}
                  : {{ 'enterprise_contract.panel_document_view.table_signing_flow.detail_content.info_approve_image' | translate }}<br /></span>
                <span *ngIf="data?.processedAt && (data?.status == enumApproverStatus.PROCESSED || data?.status == enumApproverStatus.REJECTED)">{{"approved.processing_time" | translate}}: {{data.processedAt}}<br /></span>
                <span *ngIf="data?.reason && data?.status == enumApproverStatus.REJECTED">{{"approved.reject_reason" | translate}}: {{data.reason}}<br /></span>
                <span *ngIf="data?.reason && data?.status == enumApproverStatus.PROCESSED">{{"approved.approve_content" | translate}}: {{data.reason}}<br /></span>
                <!-- Thông tin ký -->
                <div *ngIf="data.signMethod != null && data.status == enumContractUserStatus.PROCESSED">
                    <span>{{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_info" |
                      translate}}: </span>

                  <span class="ml-2" *ngIf="data.signMethod == enumSignMethod.SIGN_USB_TOKEN">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_usb_token" |
                      translate}}
                    </span>
                  <span class="ml-2" *ngIf="data.signMethod == enumSignMethod.SIGN_SIM_CA">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_sim_ca" |
                      translate}}
                    </span>
                  <span class="ml-2" *ngIf="data.signMethod == enumSignMethod.SIGN_OTP">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp" |
                      translate}}
                    </span>
                  <span class="ml-2" *ngIf="data.signMethod == enumSignMethod.SIGN_SERVER">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_hsm" |
                      translate}}
                    </span>
                  <span class="ml-2" *ngIf="data.signMethod == enumSignMethod.SIGN_IMAGE">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_image" |
                      translate}}
                    </span>
                  <span class="ml-2" *ngIf="data.signMethod == enumSignMethod.SIGN_OTP_EKYC">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                    :
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc" |
                      translate}}
                    </span>
                  <span class="ml-2" *ngIf="data.signMethod == enumSignMethod.SIGN_OTP_EKYC_ADVANCED">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}
                    :
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_otp_ekyc_advanced"
                      | translate}}
                    </span>
                  <span class="ml-2" *ngIf="data.signMethod == enumSignMethod.SIGN_NO_CERT">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_no_cert" |
                      translate}}
                    </span>
                  <span class="ml-2" *ngIf="data.signMethod == enumSignMethod.CLOUD_CA">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                      translate}}:
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_cloud_ca" |
                      translate}}
                    </span>
                    <span class="ml-2" *ngIf="data.signMethod == enumSignMethod.VNEID">-
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_method" |
                        translate}}:
                      {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.sign_vneid" |
                        translate}}
                      </span>
                  <span class="ml-2" *ngIf=" data.signMetadata && (data.signMethod == enumSignMethod.SIGN_USB_TOKEN
                    || data.signMethod == enumSignMethod.SIGN_SIM_CA
                    || data.signMethod == enumSignMethod.SIGN_SERVER
                    || data.signMethod == enumSignMethod.CLOUD_CA)">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.issued_to" |
                      translate}}:
                    {{ data.signMetadata.issuedTo }}
                    </span>
                  <span class="ml-2" *ngIf="data.signMetadata && (data.signMethod == enumSignMethod.SIGN_USB_TOKEN
                    || data.signMethod == enumSignMethod.SIGN_SIM_CA
                    || data.signMethod == enumSignMethod.SIGN_SERVER
                    || data.signMethod == enumSignMethod.CLOUD_CA)">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.serial_number" |
                      translate}}:
                    {{ data.signMetadata.serialNumber }}
                    </span>
                  <span class="ml-2" *ngIf="data.signMetadata && (data.signMethod == enumSignMethod.SIGN_USB_TOKEN
                    || data.signMethod == enumSignMethod.SIGN_SIM_CA
                    || data.signMethod == enumSignMethod.SIGN_SERVER
                    || data.signMethod == enumSignMethod.CLOUD_CA)">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.certificate_no" |
                      translate}}:
                    {{ data.signMetadata.certificateNo }}
                    </span>
                  <span class="ml-2"
                        *ngIf="data.signMetadata && (data.signMethod == enumSignMethod.SIGN_OTP || data.signMethod == enumSignMethod.SIGN_SIM_CA)
                      || data.signMethod == enumSignMethod.SIGN_OTP_EKYC_ADVANCED || data.signMethod == enumSignMethod.SIGN_OTP_EKYC">-
                    {{"enterprise_contract.panel_document_view.table_signing_flow.detail_content.phone_number" |
                      translate}}:
                    {{ data.signMetadata.phoneNumber }}
                    </span>
                </div>
                <!-- END of Thông tin ký -->
              </td>
              <td>&nbsp;</td>
            </tr>
          </ng-container>
        </tbody>
      </nz-table>
    </div>
  </mat-expansion-panel>

  <div *ngIf="document.ceStatus == 6">
    <div class="px-4 text-center" [innerHTML]="getMessageNoteSignFlowDesign()"></div>
  </div>
</mat-accordion>
<ng-template #contentEmptyTable let-name>
</ng-template>
